import { Rect, Svg } from "@react-pdf/renderer";
import { create } from "qrcode";
import { SvgIconProps } from "./SvgIconProps";
import { useMemo } from "react";

type QrCodeProps = { text: string } & SvgIconProps;

const VIEW_BOX_SIZE = 100;

const QrCode: React.FC<QrCodeProps> = (props) => {
  const { text, width, height, ...svgProps } = props;

  const qrdata = useMemo(() => create(text).modules, [text]);

  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${VIEW_BOX_SIZE} ${VIEW_BOX_SIZE}`}
      {...svgProps}
    >
      {Array.from({ length: qrdata.size }).map((_, y) =>
        Array.from({ length: qrdata.size }).map((_, x) =>
          qrdata.get(x, y) ? (
            <Rect
              key={`${x}-${y}`}
              x={(x * VIEW_BOX_SIZE) / qrdata.size}
              y={(y * VIEW_BOX_SIZE) / qrdata.size}
              width={VIEW_BOX_SIZE / qrdata.size}
              height={VIEW_BOX_SIZE / qrdata.size}
            />
          ) : null,
        ),
      )}
    </Svg>
  );
};

export default QrCode;
